(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-about"]) return;
  try {
    
  (function () {
    function initDDTimeline() {
      var root = document.querySelector('[data-dd-tl]');
      if (!root) return;

      var strip = root.querySelector('[data-dd-tl-strip]');
      var line = root.querySelector('[data-dd-tl-line]');
      var panels = root.querySelectorAll('[data-dd-tl-panel]');
      var n = panels.length;
      var mq = window.matchMedia('(min-width: 900px)');
      var distance = 0;
      var base = 0;
      var top = 88;
      var active = false;
      var ticking = false;

      function headerHeight() {
        var bar = document.querySelector('[data-dd-header-bar]');
        return bar ? bar.offsetHeight : 88;
      }

      function layout() {
        active = mq.matches && n > 1;

        if (!active) {
          root.style.height = '';
          strip.style.transform = '';
          if (line) line.style.transform = '';
          return;
        }

        var vw = document.documentElement.clientWidth;
        top = headerHeight();

        // Bord gauche exact du conteneur 1160px des frames 1 à 3
        var ref = document.querySelector('.dd-about-page');
        var left = ref ? ref.getBoundingClientRect().left : Math.max(40, (vw - 1160) / 2);

        distance = (n - 1) * vw;
        base = vw - 2 * left; // longueur d'un séparateur normal

        root.style.setProperty('--dd-tl-vw', vw + 'px');
        root.style.setProperty('--dd-tl-left', left + 'px');
        root.style.setProperty('--dd-tl-top', top + 'px');
        root.style.setProperty('--dd-tl-dist', distance + 'px');

        root.style.height = (distance + window.innerHeight - top) + 'px';

        if (window.__ddLenis && typeof window.__ddLenis.resize === 'function') {
          window.__ddLenis.resize();
        }

        update();
      }

      function update() {
        ticking = false;
        if (!active) return;

        var rect = root.getBoundingClientRect();
        var scrolled = Math.min(Math.max(top - rect.top, 0), distance);

        strip.style.transform = 'translate3d(' + (-scrolled) + 'px, 0, 0)';

        // Trait : longueur d'un séparateur normal au départ, puis il
        // s'allonge de la distance scrollée — son extrémité droite reste
        // ainsi calée sur la marge droite de l'écran.
        if (line) {
          var scale = (base + scrolled) / (base + distance);
          line.style.transform = 'scaleX(' + scale + ')';
        }
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      // Précharge les médias des étapes hors écran dès que la frise approche
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            root.querySelectorAll('[data-dd-tl-preload]').forEach(function (el) {
              el.setAttribute('loading', 'eager');
            });
            io.disconnect();
          });
        }, { rootMargin: '0px 0px 150% 0px' });
        io.observe(root);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      if (window.__ddLenis && typeof window.__ddLenis.on === 'function') {
        window.__ddLenis.on('scroll', onScroll);
      }
      window.addEventListener('resize', layout);
      window.addEventListener('load', layout);
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', layout);
      }

      layout();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDTimeline);
    } else {
      initDDTimeline();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cart"]) return;
  try {
    
  (function () {
    function initDDCart() {
      var root = document.querySelector('[data-dd-cart]');
      if (!root) return;

      var isUpdating = false;

      function readCartData() {
        var script = root.querySelector('[data-dd-cart-data]');
        var data = { currency: '', total: 0, items: [] };
        if (script) {
          try {
            data = JSON.parse(script.textContent);
          } catch (e) {
            data = { currency: '', total: 0, items: [] };
          }
        }
        return data;
      }

      function setUpdating(state) {
        isUpdating = state;
        root.classList.toggle('is-updating', state);
      }

      function changeLine(line, quantity) {
        if (isUpdating) return;
        setUpdating(true);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function () {
            return fetch('/cart');
          })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newRoot = doc.querySelector('[data-dd-cart]');
            if (newRoot && root.parentNode) {
              root.parentNode.replaceChild(newRoot, root);
              root = newRoot;
              bindEvents();
            }
            setUpdating(false);
          })
          .catch(function () {
            setUpdating(false);
          });
      }

      function bindEvents() {
        root.querySelectorAll('[data-dd-cart-qty-increase]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var line = parseInt(btn.getAttribute('data-line'), 10);
            var valueEl = btn.parentElement.querySelector('[data-dd-cart-qty-value]');
            var newQty = parseInt(valueEl.textContent, 10) + 1;
            changeLine(line, newQty);
          });
        });

        root.querySelectorAll('[data-dd-cart-qty-decrease]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var line = parseInt(btn.getAttribute('data-line'), 10);
            var valueEl = btn.parentElement.querySelector('[data-dd-cart-qty-value]');
            var newQty = parseInt(valueEl.textContent, 10) - 1;
            changeLine(line, Math.max(0, newQty));
          });
        });

        root.querySelectorAll('[data-dd-cart-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var line = parseInt(btn.getAttribute('data-line'), 10);
            changeLine(line, 0);
          });
        });

        var checkoutForm = root.querySelector('[data-dd-cart-checkout-form]');
        if (checkoutForm) {
          checkoutForm.addEventListener('submit', function () {
            var cartData = readCartData();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'begin_checkout',
              ecommerce: {
                currency: cartData.currency,
                value: cartData.total,
                items: cartData.items
              }
            });
          });
        }
      }

      bindEvents();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDCart);
    } else {
      initDDCart();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  (function () {
    function initDDHeader() {
      var header = document.querySelector('[data-dd-header]');
      if (!header) return;

      var bar = header.querySelector('[data-dd-header-bar]');
      var toggle = header.querySelector('[data-dd-header-toggle]');
      var panel = header.querySelector('[data-dd-header-panel]');
      var overlay = header.querySelector('[data-dd-header-overlay]');
      var glass = header.querySelector('[data-dd-header-glass]');
      var spacer = document.querySelector('[data-dd-header-spacer]');

      function syncSpacerHeight() {
        if (!spacer) return;
        spacer.style.height = bar.offsetHeight + 'px';
      }

      function positionOverlay() {
        var barHeight = bar.offsetHeight;
        var panelHeight = panel.offsetHeight;
        var isOpenNow = header.getAttribute('data-open') === 'true';
        overlay.style.top = (barHeight + panelHeight) + 'px';
        glass.style.height = (barHeight + (isOpenNow ? panelHeight : 0)) + 'px';
      }

      function openMenu() {
        header.setAttribute('data-open', 'true');
        toggle.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        positionOverlay();
      }

      function closeMenu() {
        header.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        positionOverlay();
      }

      function isOpen() {
        return header.getAttribute('data-open') === 'true';
      }

      toggle.addEventListener('click', function () {
        if (isOpen()) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      overlay.addEventListener('click', closeMenu);

      document.addEventListener('click', function (event) {
        if (isOpen() && !header.contains(event.target)) {
          closeMenu();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
          closeMenu();
          toggle.focus();
        }
      });

      window.addEventListener('resize', function () {
        closeMenu();
        positionOverlay();
        syncSpacerHeight();
      });

      positionOverlay();
      syncSpacerHeight();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDHeader);
    } else {
      initDDHeader();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-video"]) return;
  try {
    
  (function () {
    function initDDHeroVideo() {
      var video = document.querySelector('[data-dd-hero-video]');
      if (!video) return;
      // Some browsers only honor autoplay if muted is also set as a
      // JS property, not just the HTML attribute.
      video.muted = true;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          // Autoplay was blocked — no-op, the video simply stays paused.
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDHeroVideo);
    } else {
      initDDHeroVideo();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"]) return;
  try {
    
  (function () {
    function initDDNewsletterModal() {
      var modal = document.querySelector('[data-dd-newsletter-modal]');
      if (!modal) return;

      var triggers = document.querySelectorAll('[data-dd-newsletter-signup]');
      var overlay = modal.querySelector('[data-dd-newsletter-modal-overlay]');
      var closeBtn = modal.querySelector('[data-dd-newsletter-modal-close]');

      function openModal() {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', openModal);
      });

      if (overlay) overlay.addEventListener('click', closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });

      // Rouvre automatiquement le pop-up après un rechargement de page
      // consécutif à une soumission réussie du formulaire, pour que le
      // message de confirmation soit visible.
      if (modal.dataset.ddNewsletterModalOpen === 'true') {
        openModal();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDNewsletterModal);
    } else {
      initDDNewsletterModal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-projects"]) return;
  try {
    
  (function () {
    function initDDProjects() {
      var root = document.querySelector('[data-dd-projects]');
      if (!root) return;

      var grid = root.querySelector('[data-dd-projects-grid]');
      var filterButtons = root.querySelectorAll('[data-dd-filter]');
      var items = root.querySelectorAll('[data-dd-projects-item]');
      var countValue = root.querySelector('[data-dd-projects-count-value]');
      var activeFilters = [];

      // Hover interaction: whiten every other visible card — same
      // mechanic as the Shop page (sections/custom-shop.liquid).
      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          if (grid) grid.classList.add('is-hovering');
          item.classList.add('is-hovered');
        });

        item.addEventListener('mouseleave', function () {
          if (grid) grid.classList.remove('is-hovering');
          item.classList.remove('is-hovered');
        });
      });

      // Category filters: multi-select, OR logic, soft fade + reflow —
      // same mechanic as the Shop page.
      function applyFilters() {
        var visibleCount = 0;

        items.forEach(function (item) {
          var tagsAttr = item.getAttribute('data-dd-tags') || '';
          var tags = tagsAttr.split(' ').filter(Boolean);
          var matches =
            activeFilters.length === 0 ||
            activeFilters.some(function (filter) {
              return tags.indexOf(filter) !== -1;
            });

          if (matches) {
            visibleCount += 1;
            item.classList.remove('dd-projects__item--gone');
            void item.offsetWidth;
            item.classList.remove('dd-projects__item--hidden');
          } else {
            item.classList.add('dd-projects__item--hidden');
            window.setTimeout(function () {
              if (item.classList.contains('dd-projects__item--hidden')) {
                item.classList.add('dd-projects__item--gone');
              }
            }, 300);
          }
        });

        if (countValue) {
          countValue.textContent = visibleCount;
        }
      }

      var filterButtonsArr = Array.prototype.slice.call(filterButtons);

      filterButtonsArr.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.getAttribute('data-dd-filter');

          if (filter === 'all') {
            activeFilters = [];
            filterButtonsArr.forEach(function (btn) {
              btn.classList.toggle('is-active', btn === button);
            });
          } else {
            var index = activeFilters.indexOf(filter);
            if (index === -1) {
              activeFilters.push(filter);
            } else {
              activeFilters.splice(index, 1);
            }

            button.classList.toggle('is-active', activeFilters.indexOf(filter) !== -1);

            var allButton = root.querySelector('[data-dd-filter="all"]');
            if (allButton) {
              allButton.classList.toggle('is-active', activeFilters.length === 0);
            }
          }

          applyFilters();
        });
        button.__ddReady = true;
      });

      // Rejoue les clics arrivés avant que ces écouteurs soient attachés
      // (cf. early click-buffer dans layout/theme.liquid).
      if (window.__ddPendingClicks && window.__ddPendingClicks.length) {
        window.__ddPendingClicks = window.__ddPendingClicks.filter(function (el) {
          if (filterButtonsArr.indexOf(el) !== -1) {
            el.click();
            return false;
          }
          return true;
        });
      }

      applyFilters();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDProjects);
    } else {
      initDDProjects();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shop"]) return;
  try {
    
  (function () {
    function initDDShop() {
      var root = document.querySelector('[data-dd-shop]');
      if (!root) return;

      var grid = root.querySelector('[data-dd-shop-grid]');
      var filterButtons = root.querySelectorAll('[data-dd-filter]');
      var items = root.querySelectorAll('[data-dd-shop-item]');
      var countValue = root.querySelector('[data-dd-shop-count-value]');
      var activeFilters = [];

      function pickRandomIndex(excludeIndex, total) {
        if (total <= 1) return excludeIndex;
        var next;
        do {
          next = Math.floor(Math.random() * total);
        } while (next === excludeIndex);
        return next;
      }

      // Hover interaction: swap to another photo of the same variant and
      // whiten every other visible card, mirroring product-showcase.js.
      items.forEach(function (item) {
        var images = item.querySelectorAll('[data-dd-item-image]');
        var currentIndex = 0;

        item.addEventListener('mouseenter', function () {
          if (grid) grid.classList.add('is-hovering');
          item.classList.add('is-hovered');

          if (images.length > 1) {
            var nextIndex = pickRandomIndex(currentIndex, images.length);
            images[currentIndex].classList.remove('is-active');
            images[nextIndex].classList.add('is-active');
            currentIndex = nextIndex;
          }
        });

        item.addEventListener('mouseleave', function () {
          if (grid) grid.classList.remove('is-hovering');
          item.classList.remove('is-hovered');

          if (currentIndex !== 0) {
            images[currentIndex].classList.remove('is-active');
            images[0].classList.add('is-active');
            currentIndex = 0;
          }
        });
      });

      // Category filters: multi-select, OR logic, soft fade + reflow.
      function applyFilters() {
        var visibleCount = 0;

        items.forEach(function (item) {
          var tagsAttr = item.getAttribute('data-dd-tags') || '';
          var tags = tagsAttr.split(' ').filter(Boolean);
          var matches =
            activeFilters.length === 0 ||
            activeFilters.some(function (filter) {
              return tags.indexOf(filter) !== -1;
            });

          if (matches) {
            visibleCount += 1;
            item.classList.remove('dd-shop__item--gone');
            void item.offsetWidth;
            item.classList.remove('dd-shop__item--hidden');
          } else {
            item.classList.add('dd-shop__item--hidden');
            window.setTimeout(function () {
              if (item.classList.contains('dd-shop__item--hidden')) {
                item.classList.add('dd-shop__item--gone');
              }
            }, 300);
          }
        });

        if (countValue) {
          countValue.textContent = visibleCount;
        }
      }

      var filterButtonsArr = Array.prototype.slice.call(filterButtons);

      filterButtonsArr.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.getAttribute('data-dd-filter');

          if (filter === 'all') {
            activeFilters = [];
            filterButtonsArr.forEach(function (btn) {
              btn.classList.toggle('is-active', btn === button);
            });
          } else {
            var index = activeFilters.indexOf(filter);
            if (index === -1) {
              activeFilters.push(filter);
            } else {
              activeFilters.splice(index, 1);
            }

            button.classList.toggle('is-active', activeFilters.indexOf(filter) !== -1);

            var allButton = root.querySelector('[data-dd-filter="all"]');
            if (allButton) {
              allButton.classList.toggle('is-active', activeFilters.length === 0);
            }
          }

          applyFilters();
        });
        button.__ddReady = true;
      });

      // Rejoue les clics arrivés avant que ces écouteurs soient attachés
      // (cf. early click-buffer dans layout/theme.liquid).
      if (window.__ddPendingClicks && window.__ddPendingClicks.length) {
        window.__ddPendingClicks = window.__ddPendingClicks.filter(function (el) {
          if (filterButtonsArr.indexOf(el) !== -1) {
            el.click();
            return false;
          }
          return true;
        });
      }

      applyFilters();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDShop);
    } else {
      initDDShop();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-flare-faq"]) return;
  try {
    
  (function () {
    function initDDFaq() {
      var root = document.querySelector('[data-dd-faq]');
      if (!root) return;

      var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-dd-faq-item]'));
      faqItems.forEach(function (item) {
        var trigger = item.querySelector('[data-dd-faq-trigger]');
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', (!isOpen).toString());
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDFaq);
    } else {
      initDDFaq();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-flare-obsession"]) return;
  try {
    
  (function () {
    function initDDObsessionVideo() {
      var videos = document.querySelectorAll('[data-dd-obsession-video]');
      videos.forEach(function (video) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            // Autoplay bloqué par le navigateur — la vidéo reste en pause.
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDObsessionVideo);
    } else {
      initDDObsessionVideo();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-flare-story"]) return;
  try {
    
  (function () {
    function initDDStoryVideos() {
      var videos = document.querySelectorAll('[data-dd-story-video]');
      videos.forEach(function (video) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            // Autoplay bloqué par le navigateur — la vidéo reste en pause.
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDStoryVideos);
    } else {
      initDDStoryVideos();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-flare"]) return;
  try {
    
  (function () {
    function initFlare() {
      var root = document.querySelector('[data-dd-flare]');
      if (!root) return;

      var galleriesScript = root.querySelector('[data-dd-flare-galleries]');
      var galleries = {};
      try {
        galleries = JSON.parse(galleriesScript.textContent);
      } catch (e) {
        galleries = {};
      }

      var frame = root.querySelector('.dd-flare__gallery-frame');
      var img = root.querySelector('[data-dd-flare-image]');
      var counter = root.querySelector('[data-dd-flare-counter]');
      var prevBtn = root.querySelector('[data-dd-flare-prev]');
      var nextBtn = root.querySelector('[data-dd-flare-next]');
      var variantInput = root.querySelector('[data-dd-flare-variant-input]');
      var finishButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dd-flare-finish]'));

      var lightbox = root.querySelector('[data-dd-flare-lightbox]');
      var lightboxFrame = root.querySelector('[data-dd-flare-lightbox-frame]');
      var lightboxImg = root.querySelector('[data-dd-flare-lightbox-image]');
      var lightboxCounter = root.querySelector('[data-dd-flare-lightbox-counter]');
      var lightboxClose = root.querySelector('[data-dd-flare-lightbox-close]');
      var lightboxPrev = root.querySelector('[data-dd-flare-lightbox-prev]');
      var lightboxNext = root.querySelector('[data-dd-flare-lightbox-next]');
      var lightboxOpen = false;
      var suppressLightboxClick = false;

      var currentColor = root.dataset.defaultColor;
      var currentIndex = 0;
      var renderToken = 0;

      var preloaded = {};

      function preloadSet(colorKey) {
        if (preloaded[colorKey]) return;
        preloaded[colorKey] = true;
        var entry = galleries[colorKey];
        if (!entry) return;
        [entry.main].concat(entry.gallery || []).forEach(function (url) {
          var preloadImg = new Image();
          preloadImg.src = url;
        });
      }

      function currentSet() {
        var entry = galleries[currentColor];
        if (!entry) return [];
        return [entry.main].concat(entry.gallery || []);
      }

      function getFadeDuration() {
        var value = window.getComputedStyle(img).transitionDuration;
        var seconds = parseFloat(value);
        if (!seconds) return 200;
        return seconds * 1000;
      }

      function renderImage() {
        var set = currentSet();
        if (!set.length) return;
        var nextSrc = set[currentIndex];
        counter.textContent = (currentIndex + 1) + '/' + set.length;
        if (lightboxOpen && lightboxCounter) {
          lightboxCounter.textContent = (currentIndex + 1) + '/' + set.length;
        }

        var token = ++renderToken;
        var duration = getFadeDuration();

        img.classList.add('is-fading');
        if (lightboxOpen && lightboxImg) {
          lightboxImg.classList.add('is-fading');
        }

        window.setTimeout(function () {
          if (token !== renderToken) return;
          img.src = nextSrc;
          if (lightboxOpen && lightboxImg) {
            lightboxImg.src = nextSrc;
          }
          requestAnimationFrame(function () {
            if (token !== renderToken) return;
            img.classList.remove('is-fading');
            if (lightboxOpen && lightboxImg) {
              lightboxImg.classList.remove('is-fading');
            }
          });
        }, duration);
      }

      function openLightbox() {
        var set = currentSet();
        if (!set.length || !lightbox) return;
        lightboxImg.src = set[currentIndex];
        lightboxCounter.textContent = (currentIndex + 1) + '/' + set.length;
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (window.__ddLenis) {
          window.__ddLenis.stop();
        }
        lightboxOpen = true;
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (window.__ddLenis) {
          window.__ddLenis.start();
        }
        lightboxOpen = false;
      }

      function setColor(colorKey) {
        if (!galleries[colorKey]) return;
        currentColor = colorKey;
        currentIndex = 0;

        finishButtons.forEach(function (btn) {
          var isSelected = btn.dataset.color === colorKey;
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (variantInput && galleries[colorKey].variantId) {
          variantInput.value = galleries[colorKey].variantId;
        }

        renderImage();
      }

      function goToNext() {
        var set = currentSet();
        if (!set.length) return;
        currentIndex = (currentIndex + 1) % set.length;
        renderImage();
      }

      function goToPrev() {
        var set = currentSet();
        if (!set.length) return;
        currentIndex = (currentIndex - 1 + set.length) % set.length;
        renderImage();
      }

      finishButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setColor(btn.dataset.color);
        });
        btn.__ddReady = true;
      });

      // Rejoue les clics arrivés avant que ces écouteurs soient attachés
      // (cf. early click-buffer dans layout/theme.liquid).
      if (window.__ddPendingClicks && window.__ddPendingClicks.length) {
        window.__ddPendingClicks = window.__ddPendingClicks.filter(function (el) {
          if (finishButtons.indexOf(el) !== -1) {
            el.click();
            return false;
          }
          return true;
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', goToPrev);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', goToNext);
      }

      // Touch swipe support for the gallery frame (mobile)
      if (frame) {
        var touchStartX = 0;
        var touchStartY = 0;
        var touchActive = false;

        frame.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          touchActive = true;
        }, { passive: true });

        frame.addEventListener('touchend', function (e) {
          if (!touchActive) return;
          touchActive = false;
          if (!e.changedTouches || !e.changedTouches.length) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          suppressLightboxClick = true;
          if (dx < 0) {
            goToNext();
          } else {
            goToPrev();
          }
        }, { passive: true });

        frame.addEventListener('click', function () {
          if (suppressLightboxClick) {
            suppressLightboxClick = false;
            return;
          }
          openLightbox();
        });
      }

      if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox);
      }

      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) {
            closeLightbox();
          }
        });
      }

      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', goToPrev);
      }

      if (lightboxNext) {
        lightboxNext.addEventListener('click', goToNext);
      }

      document.addEventListener('keydown', function (e) {
        if (!lightboxOpen) return;
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowRight') {
          goToNext();
        } else if (e.key === 'ArrowLeft') {
          goToPrev();
        }
      });

      // Touch swipe support inside the lightbox too
      if (lightboxFrame) {
        var lbTouchStartX = 0;
        var lbTouchStartY = 0;
        var lbTouchActive = false;

        lightboxFrame.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) return;
          lbTouchStartX = e.touches[0].clientX;
          lbTouchStartY = e.touches[0].clientY;
          lbTouchActive = true;
        }, { passive: true });

        lightboxFrame.addEventListener('touchend', function (e) {
          if (!lbTouchActive) return;
          lbTouchActive = false;
          if (!e.changedTouches || !e.changedTouches.length) return;
          var lbDx = e.changedTouches[0].clientX - lbTouchStartX;
          var lbDy = e.changedTouches[0].clientY - lbTouchStartY;
          if (Math.abs(lbDx) < 40 || Math.abs(lbDx) < Math.abs(lbDy)) return;
          if (lbDx < 0) {
            goToNext();
          } else {
            goToPrev();
          }
        }, { passive: true });
      }

      Object.keys(galleries).forEach(preloadSet);

      var initialSet = currentSet();
      if (initialSet.length) {
        counter.textContent = '1/' + initialSet.length;
      }

      // FAQ accordion
      var faqItems = Array.prototype.slice.call(root.querySelectorAll('[data-dd-faq-item]'));
      faqItems.forEach(function (item) {
        var trigger = item.querySelector('[data-dd-faq-trigger]');
        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', (!isOpen).toString());
        });
      });

      // Description "Learn more" / "Close" toggle
      var descriptionWrap = root.querySelector('.dd-flare__description');
      var descriptionToggle = root.querySelector('[data-dd-description-toggle]');
      var descriptionClose = root.querySelector('[data-dd-description-close]');
      var descriptionMore = root.querySelector('[data-dd-description-more]');

      function setDescriptionOpen(isOpen) {
        if (descriptionWrap) {
          descriptionWrap.classList.toggle('is-open', isOpen);
        }
        if (descriptionMore) {
          descriptionMore.classList.toggle('is-open', isOpen);
        }
        if (descriptionToggle) {
          descriptionToggle.setAttribute('aria-expanded', isOpen.toString());
        }
      }

      if (descriptionToggle) {
        descriptionToggle.addEventListener('click', function () {
          setDescriptionOpen(true);
        });
      }

      if (descriptionClose) {
        descriptionClose.addEventListener('click', function () {
          setDescriptionOpen(false);
        });
      }

      // GTM / GA4 dataLayer — add_to_cart, lu depuis l'état courant du
      // formulaire (finition sélectionnée) au moment de l'envoi.
      var orderForm = root.querySelector('.dd-flare__form');
      if (orderForm) {
        orderForm.addEventListener('submit', function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: root.dataset.shopCurrency,
              value: parseFloat(root.dataset.variantPrice),
              items: [{
                item_id: variantInput ? variantInput.value : '',
                item_name: root.dataset.productTitle,
                item_variant: currentColor,
                price: parseFloat(root.dataset.variantPrice),
                quantity: 1
              }]
            }
          });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFlare);
    } else {
      initFlare();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase-video"]) return;
  try {
    
  (function () {
    function initDDVideoCaption() {
      var videos = document.querySelectorAll('[data-dd-video-caption]');
      videos.forEach(function (video) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            // Autoplay bloqué par le navigateur — la vidéo reste simplement en pause.
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDDVideoCaption);
    } else {
      initDDVideoCaption();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-outro"]) return;
  try {
    
  (function () {
    function initProductVideoOutro() {
      var video = document.querySelector('[data-product-video-outro]');
      if (!video) return;
      video.muted = true;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          // Autoplay bloqué par le navigateur — la vidéo reste simplement en pause.
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductVideoOutro);
    } else {
      initProductVideoOutro();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShopFilters() {
      var filterGroup = document.querySelector('[data-shop-filters]');
      if (!filterGroup) return;

      var buttons = Array.prototype.slice.call(filterGroup.querySelectorAll('.shop-filter'));
      var items = Array.prototype.slice.call(document.querySelectorAll('.product-grid__item'));
      var countEl = document.querySelector('[data-shop-count]');
      var TRANSITION_MS = 300;
      var active = new Set(['all']);

      function visibleItems() {
        if (active.has('all')) return items;
        return items.filter(function (item) {
          var tags = (item.dataset.tags || '').trim().split(/[\s,]+/).filter(Boolean);
          return tags.some(function (tag) { return active.has(tag); });
        });
      }

      function updateCount(list) {
        if (!countEl) return;
        var n = list.length;
        countEl.textContent = n + (n > 1 ? ' résultats' : ' résultat');
      }

      function applyFilter() {
        var firstRects = new Map();
        items.forEach(function (item) { firstRects.set(item, item.getBoundingClientRect()); });

        var visible = new Set(visibleItems());

        items.forEach(function (item) {
          if (visible.has(item)) {
            item.classList.remove('is-leaving');
            item.style.display = '';
          } else {
            item.classList.add('is-leaving');
          }
        });

        requestAnimationFrame(function () {
          items.forEach(function (item) {
            if (!visible.has(item)) return;
            var first = firstRects.get(item);
            var last = item.getBoundingClientRect();
            var dx = first.left - last.left;
            var dy = first.top - last.top;
            if (dx || dy) {
              item.style.transition = 'none';
              item.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
              requestAnimationFrame(function () {
                item.style.transition = 'transform ' + TRANSITION_MS + 'ms ease';
                item.style.transform = '';
              });
            }
          });

          items.forEach(function (item) {
            if (visible.has(item)) return;
            window.setTimeout(function () {
              if (item.classList.contains('is-leaving')) item.style.display = 'none';
            }, TRANSITION_MS);
          });

          updateCount(Array.from(visible));
        });
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.dataset.filter;

          if (value === 'all') {
            active = new Set(['all']);
          } else {
            active.delete('all');
            if (active.has(value)) {
              active.delete(value);
            } else {
              active.add(value);
            }
            if (active.size === 0) active = new Set(['all']);
          }

          buttons.forEach(function (b) {
            b.classList.toggle('is-active', active.has(b.dataset.filter));
          });

          applyFilter();
        });
      });

      updateCount(visibleItems());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShopFilters);
    } else {
      initShopFilters();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
